(function() {
  let scrollPosition = 0;

  function initializePjax() {
    if (typeof Pjax === 'undefined' || window.myThemePjaxInstance) { return; }
    
    const productSection = document.querySelector('.product-section');
    if (!productSection) return;
    
    const sectionId = productSection.id.replace('shopify-section-', '');

    try {
      const pjax = new Pjax({
        elements: "a[data-pjax-link]",
        selectors: ['title', `#ProductInfo-${sectionId}`, `#MediaGallery-${sectionId}`],
        cacheBust: false,
        timeout: 5000,
        scrollTo: false
      });
      window.myThemePjaxInstance = pjax;

      document.addEventListener('pjax:send', () => {
        scrollPosition = window.pageYOffset;
        const productGrid = document.querySelector('.product-grid-container');
        if (productGrid) productGrid.classList.add('is-loading');
      });

      document.addEventListener('pjax:complete', () => {
        window.scrollTo({ top: scrollPosition, behavior: 'instant' });
        const productGrid = document.querySelector('.product-grid-container');
        if (productGrid) productGrid.classList.remove('is-loading');
        initializeBundleSelectors();
      });
    } catch (e) { console.error("PJAX Initialization Failed:", e); }
  }

  class BundleSelector {
    constructor(container) {
      this.container = container;
      this.radioButtons = this.container.querySelectorAll('.package-selector__radio-input');
      this.sectionId = this.container.dataset.sectionId;
      this.mainProductForm = document.getElementById(`product-form-${this.sectionId}`);
      this.attachEvents();
      this.updateIncludesVisibility();
    }

    attachEvents() {
      this.radioButtons.forEach(radio => {
        radio.addEventListener('change', (event) => {
          this.updateIncludesVisibility();
          this.updateMainForm(event.target.value);
        });
      });
    }

    updateMainForm(variantId) {
      // 更新表单 hidden input
      if (this.mainProductForm) {
        const input = this.mainProductForm.querySelector('input[name="id"]');
        if (input) input.value = variantId;
      }

      // 找到变体数据
      const allVariantSelects = document.querySelectorAll(`variant-selects[data-section="${this.sectionId}"]`);
      let variant = null;
      allVariantSelects.forEach(component => {
        if (!variant && typeof component.getVariantData === 'function') {
          variant = component.getVariantData().find(v => v.id == variantId);
        }
      });

      if (!variant || !variant.featured_media) return;

      // 用 Flickity 切换主图
      const mediaId = `#Slide-${this.sectionId}-${variant.featured_media.id}`;
      const productSlider = document.querySelector(`#MediaGallery-${this.sectionId} .product-images`);
      if (productSlider && typeof Flickity !== 'undefined') {
        const flkty = Flickity.data(productSlider);
        if (flkty) {
          productSlider.selectCell(mediaId);
        }
      }
    }

    updateIncludesVisibility() {
      const allGroups = this.container.querySelectorAll('.package-selector__variant-group');
      allGroups.forEach(group => {
        const radio = group.querySelector('.package-selector__radio-input');
        const includesContainer = group.querySelector('.package-includes-container');
        const includesContent = includesContainer ? includesContainer.querySelector('.package-includes__content') : null;
        if (radio && radio.checked && includesContent && includesContainer.innerText.trim() !== '') {
          includesContainer.style.display = 'block';
        } else if (includesContainer) {
          includesContainer.style.display = 'none';
        }
      });
    }
  }

  function initializeBundleSelectors() {
    const containers = document.querySelectorAll('.package-selector-container');
    containers.forEach(container => {
      const section = container.closest('.shopify-section');
      if (section) {
        container.dataset.sectionId = section.id.replace('shopify-section-', '');
      }
      container.removeAttribute('data-bundle-initialized');
      new BundleSelector(container);
      container.setAttribute('data-bundle-initialized', 'true');
    });
  }

  function runInitialSetup() {
    initializePjax();
    initializeBundleSelectors();
  }

  document.addEventListener('DOMContentLoaded', runInitialSetup);
})();
